import React from 'react';
import SectionTitle from '../../components/SectionTitles/SectionTitle';
import Masonry from 'react-masonry-css';
import WorkItem from "../../components/Work/WorkItem";
import workData from '../../data/work/workDetails.json';

const PortfolioTwo = () => {
    const breakpointColumnsObj = {
        default: 3,
        1200: 3,
        992: 2,
        768: 2,
        576: 1
    };

    return (
        <div className="section section-padding-t90 ag-masonary-wrapper" data-bg-color="#f8faff">
            <div className="container">
                <SectionTitle
                    title="Our Works"
                    subTitle="Get your company heading in the right direction with our digital marketing strategist"
                />
            </div>
            <div className="container-fluid px-0">
                <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid mesonry-list g-0"
                    columnClassName="my-masonry-grid_column"
                >
                    {workData.map(portfolio => (
                        <WorkItem key={portfolio.id} portfolio={portfolio}/>
                    ))}
                </Masonry>
            </div>
        </div>
    )
}

export default PortfolioTwo;
